module.exports = __webpack_public_path__ + "media/images/application/temp/temp-02-fee5da28ef6c3908d883461cce03699e.jpg";